export default function didPropsChange (previousProps, currentProps, curiousAbout) {
  for (let i = 0; i < curiousAbout.length; i++) {
    const key = curiousAbout[i]
    let previousValue = previousProps[key]
    let currentValue = currentProps[key]
    if (previousValue instanceof Date) previousValue = previousValue.getTime()
    if (currentValue instanceof Date) currentValue = currentValue.getTime()
    if (previousValue !== currentValue) return true
  }
  return false
}
